import { useEffect } from "react"

export default function Privacy() {

    useEffect(() => {
        window.location.replace('https://www.revolt.tv/privacy-notice');
    }, [])

    return (
        <div className="text-white text-lg">Redirecting...</div>
    )
}